import { render, staticRenderFns } from "./TmDetails.vue?vue&type=template&id=fac438c0&scoped=true&lang=html&"
import script from "./TmDetails.vue?vue&type=script&lang=ts&"
export * from "./TmDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TmDetails.vue?vue&type=style&index=0&id=fac438c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac438c0",
  null
  
)

export default component.exports